<template>
  <v-container class="pt-1 pb-3 px-0">
    <v-divider class="darky"></v-divider>
    <v-row>
      <QuestionStatus 
        :resp="resp"
        :dialog_comment.sync="add_comment"
        @dialog_update="confirm_no_file = true"
      />
      <v-divider vertical inset></v-divider>
      <v-col class="text-left py-0">
        <v-form 
          lazy-validation
          :ref="`resp-${resp.id}`"
          v-model="respuesta"
          @submit.prevent="updateRespuesta"
        >
          <v-row
            v-if="resp.pregunta.vertical"
            class="py-2"
            style="border-bottom: 1px #f3f3f3 solid;"
          >
            <v-col class="py-0 pr-4">
              {{resp.pregunta.vertical_text}}
            </v-col>
            <div class="float-right mx-3">
              <span 
                v-if="!!resp.pregunta.previous_value 
                  && resp.status.name != 'previous_data'
                  && is_ies && editable && resp.pregunta.can_import_value" 
                class="grey--text"
              >
                {{ies_year_data.year-1}}: {{answer_options.find(a=>
                  a.value == resp.pregunta.previous_value).text}}
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="accent" v-on="on" @click="setPreviousYear(resp)">
                      <v-icon>history</v-icon>
                    </v-btn>
                  </template>
                  <span>Utilizar información de {{ies_year_data.year-1}}</span>
                </v-tooltip>
              </span>
              <v-select
                :readonly="!is_ies || !editable"
                class="mt-0 pt-0 width-field"
                style="min-width: 120px;"
                outlined
                color="accent"
                single-line
                :hide-selected="false"
                :items="answer_options"
                :rules="[v =>  Number.isInteger(v) || 'Valor requerido']"
                item-value="value"
                v-model="resp.vertical_value"
                label="respuesta"
                @change="setSaveFill(resp)"
              ></v-select>
            </div>
          </v-row>
          <span v-else>
            <v-row
              v-for="unity in horizontal_options" 
              v-if="indicador[unity.name]"
              class="py-2"
              style="border-bottom: 1px #f3f3f3 solid;"
            >
              <v-col class="py-0 pr-4">
                {{horizontal_text(unity, resp)}}
              </v-col>
              <div class="float-right mx-3">
                <v-tooltip bottom v-if="!ies_year_data.register_referance[`${unity.ref}`]">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">warning</v-icon>
                  </template>
                  <span>Debes llenar antes "Información Base"</span>
                </v-tooltip>
                <v-text-field
                  v-else
                  name="name"
                  outlined
                  single-line
                  style="min-width: 120px;"
                  :rules="[v => (v > -1 && v <= ies_year_data.register_referance[`${unity.ref}`]) 
                    || 'Excede número',
                    v => Number.isInteger(parseInt(v)) || 'Requiere número']"
                  class="mt-0 pt-0 width-field"
                  type="number"
                  @input="setSaveFill(resp)"
                  :readonly="!is_ies || !editable"
                  v-model="resp[unity.v_name]"
                  label="respuesta"
                ></v-text-field>
              </div>
            </v-row>
          </span>
          <v-row>
            <AttFiles 
              :resp="resp"
              :dialog_update.sync="confirm_no_file"
              @open_comment="add_comment = true"
              @saveFromFile="updateAnswer(resp)"
            />
            <v-col cols="8" v-if="resp.notas.length">
              <span class="px-0 amber--text text--darken-1  pt-2" v-if="hide_notes">Notas en revisión</span>
              <template v-else>
                <span class="px-0 amber--text text--darken-1  pt-2">Notas:</span>
                <v-col cols="12" class="pt-0 px-0" v-for="note in resp.notas">
                  <v-card flat color="amber lighten-5">
                    <v-card-text>
                      <b class="mr-2">{{note.author == 'ies' ? 'IES:' : 'Revisora:'}}</b>
                      <span class="note">{{note.text}}</span>
                    </v-card-text>
                  </v-card>
                </v-col cols="12">
              </template>
            </v-col>
            <v-col 
              v-if="is_ies && editable && resp.is_fill"
              align="end"
              justify="center"
            >
              <v-btn 
                color="success"
                :disabled="!respuesta || saving_response"
                :loading="saving_response"
                @click="updateAnswer(resp)"
              >Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import router from "@/router.js";
import { mapState } from "vuex";
import AttFiles from "@/components/dashboard/questions/AttFiles.vue";
import QuestionStatus from "@/components/dashboard/questions/QuestionStatus.vue";

export default {
  name: 'Question',
  components: {
      AttFiles,
      QuestionStatus,
  },  
  props:{
    resp:{
      type: Object,
      required: true,
    },
    indicador:{
      type: Object,
      required: true,
    },
    ies_year_data:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      saving_response: false,
      respuesta: undefined,
      add_comment: false,
      confirm_no_file: false,
      horizontal_options:[
        {
          "name":"entidades_academicas",
          "v_name":"entidades_academicas_value",
          "objeto":"Entidades Académicas",
          "start":"De las",
          "ref":"ent_acad"
        },
        {
          "name":"dependencias_administrativas",
          "v_name":"dependencias_administrativas_value",
          "objeto":"Dependencias Administrativas",
          "start":"De las",
          "ref":"dep_admin"
        },
        {
          "name":"planes_de_estudio",
          "v_name":"planes_de_estudio_value",
          "objeto":"Planes de Estudio",
          "start":"De los",
          "ref":"planes_est"
        },
      ],
      answer_options:[
        {
          "value":1,
          "text":"Sí",
        },
        {
          "value":0,
          "text":"No",
        },
        {
          "value":-1,
          "text":"No Aplica",
        },
      ],
    }
  },
  methods:{
    horizontal_text(question, resp){
      var number=this.ies_year_data.register_referance[question.ref];
      var previo = !!number ? `${question.start} ${number} ` : 'Del total de '
      return `${previo} ${question.objeto}, ${resp.pregunta.horizontal_text}`
    },
    updateAnswer(resp){
      const valid_values = ['entidades_academicas_value', 
        'dependencias_administrativas_value', 
        'planes_de_estudio_value', 'status', 'vertical_value']
      if (this.$refs[`resp-${resp.id}`].validate()){
        this.saving_response = true;
        const base_data = Object.keys(resp)
          //.filter(key => this.mean_info.some(x=>x.short_key == key))
          .reduce((obj, key) => {
            if (valid_values.includes(key)) 
              obj[key] = resp[key] === "" ? null : resp[key];  
            return obj;
          }, {});
        //console.log(base_data)
        if ((resp.pregunta.vertical && resp.vertical_value === 1)
          || (!resp.pregunta.vertical
            && (resp.entidades_academicas_value > 0
              ||resp.dependencias_administrativas_value > 0
              ||resp.planes_de_estudio_value > 0))){
          if ((!resp.files.length && resp.pregunta.doc_required)
            || (!resp.files.length && !resp.last_note)){
            this.confirm_no_file = true;
          }
        }
        this.$store
          .dispatch('UPDATE_ANSWER', {data:base_data, 
            answer_id:resp.id, snack_text: "Se ha guardado la respuesta"})
          .then((data) => {
            this.saving_response = false;
          })
          .catch(error =>{
            this.saving_response = false;
            console.log(error)
          });
      }
    },
    setPreviousYear(resp){
      this.$store
        .dispatch('UPDATE_ANSWER_WITH_PREVIOUS', 
          {answer_id:resp.id, snack_text: "Se ha importado la respuesta"})
    },
    changeStatus(status){
      //console.log(status)
    },
    setSaveFill(resp){
      this.$set(resp, 'is_fill', true)
    },
  },
  computed:{
    ...mapState({
      is_ies: state => state.is_ies,
      can_ies_change: state => state.ies_year_data.register_referance.status.can_ies_change,
      status_name: state => state.ies_year_data.register_referance.status.name,
    }),
    can_improve(){
      return this.resp.pregunta.previous_value < 1
    },
    editable(){
      return this.can_ies_change || 
        this.ies_year_data.register_referance.stage == 'middle' 
          && this.ies_year_data.actions_available >= 3
    },
    hide_notes(){
      return this.is_ies && this.status_name == 'in_review'
    },
  },
}
</script>

<style lang="scss" scoped>
.darks{
  border-color: black !important;
}

.darky{
  border-color: #8a8a8a !important;
}

.width-field{
  width: 90px;
}
</style>